var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDownloadImage = function SvgIconDownloadImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    fillRule: "evenodd",
    d: "M10.002 2.917c.489 0 .885.396.885.885v7.16l2.471-2.472a.885.885 0 1 1 1.252 1.253l-3.356 3.356a1.77 1.77 0 0 1-2.505 0L5.391 9.741a.885.885 0 0 1 1.252-1.252l2.473 2.472V3.802c0-.489.396-.885.886-.885m-6.2 9.74a.885.885 0 1 0-1.77 0v1.77a2.656 2.656 0 0 0 2.655 2.656h10.625a2.656 2.656 0 0 0 2.656-2.656v-1.77a.885.885 0 1 0-1.77 0v1.77a.885.885 0 0 1-.886.886H4.687a.885.885 0 0 1-.885-.886z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M10.002 2.917c.489 0 .885.396.885.885v7.16l2.471-2.472a.885.885 0 1 1 1.252 1.253l-3.356 3.356a1.77 1.77 0 0 1-2.505 0L5.391 9.741a.885.885 0 0 1 1.252-1.252l2.473 2.472V3.802c0-.489.396-.885.886-.885m-6.2 9.74a.885.885 0 1 0-1.77 0v1.77a2.656 2.656 0 0 0 2.655 2.656h10.625a2.656 2.656 0 0 0 2.656-2.656v-1.77a.885.885 0 1 0-1.77 0v1.77a.885.885 0 0 1-.886.886H4.687a.885.885 0 0 1-.885-.886z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M10.002 2.917c.489 0 .885.396.885.885v7.16l2.471-2.472a.885.885 0 1 1 1.252 1.253l-3.356 3.356a1.77 1.77 0 0 1-2.505 0L5.391 9.741a.885.885 0 0 1 1.252-1.252l2.473 2.472V3.802c0-.489.396-.885.886-.885m-6.2 9.74a.885.885 0 1 0-1.77 0v1.77a2.656 2.656 0 0 0 2.655 2.656h10.625a2.656 2.656 0 0 0 2.656-2.656v-1.77a.885.885 0 1 0-1.77 0v1.77a.885.885 0 0 1-.886.886H4.687a.885.885 0 0 1-.885-.886z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M10.002 2.917c.489 0 .885.396.885.885v7.16l2.471-2.472a.885.885 0 1 1 1.252 1.253l-3.356 3.356a1.77 1.77 0 0 1-2.505 0L5.391 9.741a.885.885 0 0 1 1.252-1.252l2.473 2.472V3.802c0-.489.396-.885.886-.885m-6.2 9.74a.885.885 0 1 0-1.77 0v1.77a2.656 2.656 0 0 0 2.655 2.656h10.625a2.656 2.656 0 0 0 2.656-2.656v-1.77a.885.885 0 1 0-1.77 0v1.77a.885.885 0 0 1-.886.886H4.687a.885.885 0 0 1-.885-.886z",
    clipRule: "evenodd"
  })));
};
export default SvgIconDownloadImage;